(function () {
    'use strict';

    angular
        .module('aricCertificationModule', [
            'services.authenticatedUser',
            'aricModule',
            'controlModule',
            'governanceProcessModule'
        ]);
})();
